import { Component, Mixins } from 'vue-property-decorator';
import CommonMixin from '@/mixins/CommonMixin';
import DetailLayout from '@/components/DetailLayout.vue';
import FileUpload from '@/components/FileUpload.vue';
import DraggableTable from '@/components/DraggableTable.vue';
import DraggableList from '@/components/DraggableList.vue';
import DocumentTree from '@/components/orderdocs/DocumentTree.vue';
import AddressField from '@/components/AddressField.vue';

@Component({
  components: {
    DetailLayout,
    FileUpload,
    DraggableTable,
    DraggableList,
    DocumentTree,
    AddressField
  }
})
export default class DetailMixin extends Mixins(CommonMixin) {}
